import { Injectable } from "@angular/core";

import { HttpCemex } from "@cemex-core/angular-services-v8";

import { EndpointsConstants } from "./../../../cemexcomponents/constants/v2/";
import { customerParameter, paymentMethod } from "./../../../cemexcomponents/types/v2";

@Injectable()
export class CustomerConfigurationService {
  private apiCustomerParameters: string;
  private apiPaymentMethods: string;

  constructor(private http: HttpCemex, private endpoint: EndpointsConstants) {
    this.apiCustomerParameters = "customerparameters";
    this.apiPaymentMethods = "paymentmethods";
  }

  private getUrl(api: string): string {
    return this.endpoint.getBasePath() + this.endpoint.V2 + this.endpoint.rcCapability + api;
  }

  getCustomerParameter(customerCode?: string, countryCode?: string): Promise<Array<any>> {
    return this.http
      .get(this.getUrl(this.apiCustomerParameters) + "?customerCode=" + customerCode + "&countryCode=" + countryCode)
      .toPromise()
      .then((response: any) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  }

  getPaymentMethods(): Promise<Array<paymentMethod>> {
    return this.http
      .get(this.getUrl(this.apiPaymentMethods))
      .toPromise()
      .then((response: any) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  }

  saveConfigurationCustomer(customerParameters: any) {
    return this.http
      .post(this.getUrl(this.apiCustomerParameters), customerParameters)
      .toPromise()
      .then((response) => {
        return Promise.resolve();
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  editConfigurationCustomer(customerParameters: any) {
    return this.http
      .put(this.getUrl(this.apiCustomerParameters), customerParameters)
      .toPromise()
      .then((response) => {
        return Promise.resolve();
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  deleteConfigurationCustomer(params: any) {
    return this.http
      .put(this.getUrl(this.apiCustomerParameters), params)
      .toPromise()
      .then((response) => {
        return Promise.resolve();
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
}
